import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-spam-more-products',
  templateUrl: './spam-more-products.page.html',
  styleUrls: ['./spam-more-products.page.scss'],
})
export class SpamMoreProductsPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onAnother = () => this.modalCtrl.dismiss(true);

  public onContinue = () => this.modalCtrl.dismiss(false);

}
